import { render, staticRenderFns } from "./ZohoWidget.vue?vue&type=template&id=38f8c000&scoped=true"
import script from "./ZohoWidget.vue?vue&type=script&lang=js"
export * from "./ZohoWidget.vue?vue&type=script&lang=js"
import style0 from "./ZohoWidget.vue?vue&type=style&index=0&id=38f8c000&prod&scoped=true&lang=scss"
import style1 from "./ZohoWidget.vue?vue&type=style&index=1&id=38f8c000&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f8c000",
  null
  
)

export default component.exports